import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const BokaMoteCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 40px auto 1rem auto;
  padding: 50px 0 50px 20px;
  width: 100%;
  background-color: var(--contrastlight);

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    padding: 50px 30px;
    max-width: 760px;
    justify-content: space-between;
  }

  @media (min-width: 1024px) {
    flex-direction: row;
    padding: 50px 60px;
    max-width: 860px;
  }
`;

const CardColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (min-width: 768px) {
    gap: 0px;
    margin-left: 20px;
  }
`;

const Cardheader = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: var(--maindark);
  letter-spacing: 1.2px;
  text-align: left;
  white-space: pre-line;

  @media (min-width: 768px) {
    font-size: 20px;
  }

  @media (min-width: 1024px) {
    font-size: 22px;
  }
`;

const BokaParagraph = styled.p`
  color: var(--darktext);
  font-weight: 300;
  font-size: 16px;
  text-align: left;
  margin: 0;

  /* Tablet  */
  @media (min-width: 768px) {
    font-size: 16px;
    margin: 30px 0 40px 0;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 18px;
    margin: 30px 0 40px 0;
  }
`;

const MoteImg = styled.img`
  width: 90%;
  height: 300px;
  object-fit: cover;
  padding: 0;
  margin: 0;
  align-self: flex-start;

  @media (min-width: 488px) {
    width: 65%;
    align-self: center;
  }
  
  @media (min-width: 768px) {
    max-width: 400px;
    height: 320px;
    margin-left: 40px;
  }

  @media (min-width: 1024px) {
    max-width: 480px;
    height: 320px;
    margin-left: 40px;
  }
`;

interface BokaMoteButtonProps {
  to?: string;
}

const BokaMoteButton = styled(Link)<BokaMoteButtonProps>`
  text-align: center;
  border-radius: 50px;
  border: none;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  background-color: var(--bg-pink);
  color: var(--mainlight);
  font-weight: 800;
  font-size: 16px;
  width: 128px;
  margin: 10px 0 30px 0;
  overflow: hidden;
  position: relative;
  z-index: 0;
  transition: transform 0.2s ease;
  padding: 12px 0;

  &:hover {
    color: var(--mainlight);
    z-index: 1;
    background-color: var(--accent-pink);
  }

  &:active {
    transform: scale(0.95);
    border: none;
    background-color: var(--accent-pink);
    color: var(--mainlight);
  }

  /* Pseudo-element for wave effect */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 300%;
    height: 100%;
    background: var(--bg-pink);
    z-index: -1;
    transform: skewX(60deg);
    transition: transform 0.5s ease;
  }

  /* Hover: Move the wave across */
  &:hover::before {
    transform: translateX(100%) skewX(-30deg);
  }
`;

interface BokaMoteProps {
  name: string;
  img: string;
  text: string;
  email: string;
  subject?: string;
  body?: string;
}

export const BokaMote: React.FC<BokaMoteProps> = ({ name, img, text, email, subject, body }) => {
  const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject || "Bokningsförfrågan")}&body=${encodeURIComponent(body || "Hej,\n\nJag är intresserad av att boka ett möte.")}`;

  return (
    <BokaMoteCard>
      <CardColumnContainer>
        <Cardheader>
          {`Nyfiken på vad vi kan åstadkomma tillsammans?`}
        </Cardheader>
        <BokaParagraph>{text.replace("{name}", name)}</BokaParagraph>
        <BokaMoteButton to={mailtoLink}>Boka möte</BokaMoteButton>
      </CardColumnContainer>
      
      <MoteImg
        src={img}
        alt={name}
      />
    </BokaMoteCard>
  );
};
